import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Logo from "../components/common/logo";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/life.css";

const Life = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "life") || {
		description: "Learn more about my personal life, interests, and podcast.",
		keywords: ["Life", "Podcast", "Personal", "Interests"]
	};

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Life | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="life" />
				<div className="content-wrapper">
					<div className="life-logo-container">
						<div className="life-logo">
							<Logo width={40} />
						</div>
					</div>

					<div className="life-main-container">
						<div className="title life-title">
							More Than Code
						</div>

						<div className="subtitle life-subtitle">
							Beyond my professional work, I'm passionate about sharing stories and insights through my personal podcast.{'\n'}
							Here you'll find more about my interests, hobbies, and the conversations that inspire me.
						</div>

						<div className="life-container">
							<div className="life-wrapper">
								<div className="podcast-section">
									<h3>My Podcast: 不可太用功</h3>
									<p>I host a personal podcast in Mandarin where I explore society and culture topics. Each episode features thoughtful conversations and reflections on the experiences that shape our world.</p>
									
									<div className="podcast-links">
										<a href="https://open.spotify.com/show/3dXNxFtJTzbWsFd3Ixm4SR" target="_blank" rel="noopener noreferrer" className="spotify-link">
											Listen on Spotify
										</a>
										<a href="https://podcasts.apple.com/ca/podcast/不可太用功/id1808982407" target="_blank" rel="noopener noreferrer" className="apple-link">
											Listen on Apple Podcasts
										</a>
										<a href="https://www.xiaoyuzhoufm.com/podcast/66d3d3ec4a0f950f849ba9ec" target="_blank" rel="noopener noreferrer" className="xiaoyuzhou-link">
											Listen on Xiao Yu Zhou
										</a>
									</div>
									
									<div className="podcast-details">
										<h4>What to Expect:</h4>
										<ul>
											<li>Deep dives into societal trends and cultural phenomena</li>
											<li>Personal stories and lessons learned from my journey</li>
											<li>Conversations with interesting people from various backgrounds</li>
											<li>Insights on cross-cultural experiences and social observations</li>
											<li>Discussions conducted in Mandarin Chinese</li>
										</ul>
									</div>
									
									<p>Stay tuned for more updates and episodes coming soon!</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="page-footer">
					<div className="copyright">
						{INFO.copyright}
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Life;
